import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const OriginalSummaryAccordion = ({ description }) => {
  const [expanded, setExpanded] = useState(false);

  const handleAccordionToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div className="original-summary-accordion">
      <Accordion expanded={expanded} onChange={handleAccordionToggle} sx={{ backgroundColor: '#EFEFEF' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <strong style={{ fontSize: '1.00rem' }}>Original Summary</strong>
        </AccordionSummary>
        <AccordionDetails style={{ width: '100%', maxWidth: '100%' }} className="text-s-nowrap">
          <div dangerouslySetInnerHTML={{ __html: description }}></div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default OriginalSummaryAccordion;
